import PropTypes from 'prop-types';

import BodyTagClassList from '@app/components/BodyTagClassList';
import { EditorEntryPointProvider } from '@app/hooks/editor';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function EditorLayout({ children }) {
  return (
    <EditorEntryPointProvider>
      <div className="Background Background--dark-gray">
        <BodyTagClassList className="Background--dark-gray" />
        {children}
      </div>
    </EditorEntryPointProvider>
  );
}

EditorLayout.propTypes = propTypes;

export default EditorLayout;
